import React from "react";
import { SideMenu, BackHeader, Model } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import DisouteImage from "./../../../assets/images/organizeEventCover.png";
let DisputeView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [model, setModel] = React.useState(false);
  return (
    <SideMenu>
      <div className="page-data-view-container">
        <br />
        <BackHeader backHanler={() => navigate(-1)} />
        <h1 className="dispute-view-heading">
          Proin et ultrices erat. Nulla pulvinar, lorem eget viverra mollis.
        </h1>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <img src={DisouteImage} className="dispute-cover-image" />
              </div>
            </Grid>
          </Grid>
          <h1 className="dispute-view-heading">Discription</h1>
          <p className="dispute-view-description">
            mi felis aliquam velit, sodales molestie est augue in quam. Praesent
            eu cursus purus. Morbi efficitur dui ipsum, at suscipit ligula
            vehicula nec. Mauris sed tortor ut erat ornare egestas. Fusce libero
            enim, facilisis quis faucibus eget, varius vel velit. Nam tristique
            dapibus molestie. Praesent arcu tellus, faucibus blandit rhoncus
            nec, convallis sit amet velit. Aenean eros ipsum, varius eu cursus
            vitae, imperdiet quis leo.{" "}
          </p>
        </Box>
        {location.state.status !== "Resolved" && (
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="dispute-acknowledge-button"
                variant="text"
                onClick={() => setModel(true)}
              >
                Acknowledge
              </Button>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                Resolved
              </Button>
            </Grid>
          </Grid>
        )}
      </div>
      <Model
        modelTitle="Acknowledge"
        width="lg"
        onClose={() => setModel(false)}
        open={model}
        buttonTitle="Submit"
        buttonHandler={() => navigate("/dispute")}
      >
        <div>
          <p className="input-heading">Acknowledge</p>
          <textarea
            className="textarea"
            placeholder="Write acknowledge here"
            rows="20"
            cols="40"
          ></textarea>
        </div>
      </Model>
    </SideMenu>
  );
};
export default DisputeView;
